import React, { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import Input from "../components/common/input";
import Select from "../components/common/select";
import UserContext from "../context/userContext";
import http from "../services/http";

const defaultModalData = {
  analyst: "",
  date: moment().format("DD-MMM-YYYY"),
  hour: moment().hour(),
  value: "",
};
const defaultNewComment = {
  id: 0,
  type: 7,
  comment: "",
};

const defaultCloseComment = {
  type: 6,
  comment: "",
};

const CCF = (props) => {
  const [user] = useContext(UserContext);
  const [CCF, setCCF] = useState({});
  const [data, setData] = useState([]);
  const [comments, setComments] = useState([]);

  const [showDataModal, setShowDataModal] = useState(false);
  const [dataModal, setDataModal] = useState(defaultModalData);

  const [commentType, setCommentType] = useState("");
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [commentModal, setCommentModal] = useState(defaultNewComment);

  const [parmCode, setParmCode] = useState(false);

  const match = props.match;
  const history = props.history;

  useEffect(() => {
    async function getCCF() {
      try {
        const { data: ccf } = await http.get(`/ccf/${match.params.id}`);
        setCCF(ccf);
      } catch (error) {
        toast.error("CCF Not found");
        history.push(`/ccf`);
      }
    }
    async function getCCFData() {
      try {

      }
      catch {
        //ignore error
      }

      setParmCode(match.params.parmCode);
    }
    async function getCCFComments() {
      try {
        const { data: comments } = await http.get(`/ccf-comments/${match.params.id}`);
        setComments(comments);
      }
      catch {
        //ignore error
      }
    }

    if (match.params.id) {
      getCCF();
      getCCFData();
      getCCFComments();
    }
  }, [match.params.parmCode, match.params.id, history]);

  const handleDataChange = ({ currentTarget: input }) => {
    const info = { ...dataModal };
    const value = input.type === "checkbox" ? input.checked : input.value;
    info[input.name] = value;
    setDataModal(info);
  };

  const handleCommentChange = ({ currentTarget: input }) => {
    const info = { ...commentModal };
    const value = input.type === "checkbox" ? input.checked : input.value;
    info[input.name] = value;
    setCommentModal(info);
  };

  const handleDataSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data } = await http.post(`/ccf-data/${CCF.id}`, dataModal);
      setShowDataModal(false);
      setData((d) => [...d, data]);
    } catch (error) {
      if (error.response && error.response.status < 500) {
        toast.error(error.response.data);
      }
    }
  };

  const handleCommentSubmit = async (e) => {
    try {
      if (commentType === "CLOSE") await handleCloseComment(commentModal);
      if (commentType === "UPDATE") await handleUpdateComment(commentModal);
      if (commentType === "NEW") await handleNewComment(commentModal);
    } catch (error) {
      if (error.response && error.response.status < 500) {
        toast.error(error.response.data);
      }
    }
  };

  const handleNewComment = async (comment) => {
    try {
      delete comment["id"];
      const { data } = await http.post(`/ccf-comments/${CCF.id}`, comment);
      setComments((c) => [...c, data]);
    }
    catch {
      //ignore error
    }

    setShowCommentModal(false);
  };

  const handleUpdateComment = async (comment) => {
    try {
      delete comment["id"];
      const { data } = await http.put(`/ccf-comments/${CCF.id}/${comment.id}`, comment);
      const newComments = [...comments];

      const index = newComments.findIndex((c) => c.id === data.id);
      newComments[index] = data;
      setShowCommentModal(false);
      setComments(newComments);
    }
    catch {
      //ignore error
    }
  };

  const handleCloseComment = async (comment) => {
    try {
      const { data } = await http.patch(`/ccf/close/${CCF.id}`, comment);
      setComments((d) => [...d, data]);
      }
    catch {
      //ignore error
    }

    setShowCommentModal(false);

    const newCCF = { ...CCF };
    newCCF.status = { code: "C", name: "Closed" };
    newCCF.closed_at = moment().format();
    newCCF.closed_by = user.USERNAME;
    setCCF(newCCF);
    const update = props ? props.updateSidebar : undefined;
    update();
  };

  function isClosed() {
    return CCF.status && (CCF.status.code === "C" || CCF.status.code === "X");
  }

  function isOpen() {
    return CCF.status && (CCF.status.code === "O" || CCF.status.code === "R");
  }

  let raisedFrom = '';

  if (CCF && CCF !== {}) {
    switch (CCF.raised_from) {
      case "DATAENTRY":
        raisedFrom = `From Data Entry, ${CCF.raised_by}`;
        break;
      case "OPERATOR":
        raisedFrom = `From ${CCF.raised_by}`;
        break;
      case "CALCULATION":
        raisedFrom = "From Calculation";
        break;
      default:
        //do nothing
        break;
    }
  }

  return (
    <>
      <div className="col mt-4">
        <div className="container">
          <div className="row mb-3">
            <div className="col">
              <div className="display-4 text-center text-primary">
                {parmCode} 
              </div>
              <div className="display-4 text-center text-primary">
              {CCF.type && CCF.type.name}{" - "}{CCF.analysis && CCF.analysis.name}
              </div>
            </div>
            <div className="col">
              <div
                className="display-4 text-right"
                style={{ fontSize: "2rem" }}
              >
                Status: {CCF.status && CCF.status.name}
                <i
                  className={
                    CCF.status &&
                    (CCF.status.code === "O" //Open
                      ? "fas fa-circle pl-3 text-warning"
                      : CCF.status.code === "R" //Pending Close
                        ? "fas fa-circle pl-3 text-primary"
                        : CCF.status.code === "C" //Closed
                          ? "fas fa-circle pl-3 text-success"
                          : CCF.status.code === "X" //Cancelled
                            ? "fas fa-circle pl-3 text-secondary"
                            : "fas fa-circle pl-3 text-danger") //Pending or undefined/null
                  }
                ></i>
              </div>
              <div
                className="display-4 text-right text-muted"
                style={{ fontSize: "1.25rem" }}
              >
                Raised {moment.utc(CCF.raised_at).calendar()}
              </div>
              <div
                className="display-4 text-right text-muted"
                style={{ fontSize: "1.25rem" }}
              >
                {raisedFrom}
              </div>
              {CCF.closed_at && (
                <div
                  className="display-4 text-right mt-3"
                  style={{ fontSize: "1.5rem" }}
                >
                  Closed {moment.utc(CCF.closed_at).calendar()}
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col text-right">
              {CCF.status && CCF.status.code !== "C"
              ? <button
                  className="btn btn-primary"
                  onClick={() => {
                    setCommentModal(defaultCloseComment);
                    setCommentType("CLOSE");
                    setShowCommentModal(true);
                  }}
                  disabled={CCF.status && CCF.status.code !== "R" && CCF.raised_from !== "OPERATOR" && CCF.raised_from !== "CALCULATION"}
                >
                  Close CCF
                </button>
              : <span />}
            </div>
          </div>
          <div className="row">
            <div className="col">
              <h3>Limits</h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>Low Absolute</th>
                    <th>Low Trigger</th>
                    <th>High Trigger</th>
                    <th>High Absolute</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{height: "28px"}}>
                    <td>{CCF.analysis ? CCF.analysis.low_absolute : ''}</td>
                    <td>{CCF.analysis ? CCF.analysis.low_trigger : ''}</td>
                    <td>{CCF.analysis ? CCF.analysis.high_trigger : ''}</td>
                    <td>{CCF.analysis ? CCF.analysis.high_absolute : ''}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            {CCF.raised_from === 'DATAENTRY'
            ? <div className="col">
                <h3>Values</h3>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Analyst</th>
                      <th>Log Timestamp</th>
                      <th>Data Timestamp</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((record) => (
                      <tr key={record.id}>
                        <td>{record.analyst}</td>
                        <td>{record.created_at != null ? moment.utc(record.created_at).calendar() : "" }</td>
                        <td>{record.real_datetime ? moment.utc(record.real_datetime).calendar() : ""}</td>
                        <td>{record.PARAM_VALUE}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            : <span />}
          </div>
          <div className="row">
            <div className="col">
              <h3>Comments</h3>
              <table className="table">
                <thead>
                  <tr>
                    <th>Timestamp</th>
                    <th>User</th>
                    <th>Type</th>
                    <th>Comment</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {comments.map((comment) => (
                    <tr key={comment.id}>
                      <td>{moment.utc(comment.timestamp).calendar()}</td>
                      <td>{comment.username}</td>
                      <td>{comment.type.name}</td>
                      <td><pre>{comment.comment}</pre></td>
                      <td>
                        {isOpen() && (
                          <button
                            className="btn btn-sm btn-outline-primary"
                            disabled={isClosed()}
                            onClick={() => {
                              setCommentModal({
                                id: comment.id,
                                type: comment.type.id,
                                comment: comment.comment,
                              });
                              setCommentType("UPDATE");
                              setShowCommentModal(true);
                            }}
                          >
                            Edit
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <div className="col text-right">
              {isOpen() && (
                <button
                  className="btn btn-outline-primary"
                  onClick={() => {
                    setCommentModal(defaultNewComment);
                    setCommentType("NEW");
                    setShowCommentModal(true);
                  }}
                  disabled={!isOpen()}
                >
                  Add Comment
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <DataModal
        show={showDataModal}
        data={dataModal}
        onHide={() => setShowDataModal(false)}
        onChange={handleDataChange}
        onSubmit={handleDataSubmit}
      />
      <CommentModal
        show={showCommentModal}
        data={commentModal}
        onHide={() => setShowCommentModal(false)}
        onChange={handleCommentChange}
        onSubmit={handleCommentSubmit}
        commentType={commentType}
      />
    </>
  );
};

const DataModal = ({ data, show, onHide, onChange, onSubmit }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title>New Data</Modal.Title>
      </Modal.Header> 
      <form>
        <Modal.Body>
          <Input
            name="analyst"
            label="Analyst"
            placeholder="Username"
            value={data.analyst}
            onChange={onChange}
          />
          <Input
            name="date"
            label="Date"
            placeholder="Date"
            value={data.date}
            onChange={onChange}
          />
          <Input
            name="hour"
            label="Hour"
            placeholder="Hour"
            value={data.hour}
            onChange={onChange}
          />
          <Input
            name="value"
            label="Value"
            placeholder="Value"
            value={data.value}
            onChange={onChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={onSubmit}>
            Submit
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

const CommentModal = ({
  data,
  show,
  onHide,
  onChange,
  onSubmit,
  commentType,
}) => {
  const [types, setTypes] = useState([]);

  useEffect(() => {
    async function getTypes() {
      try {
        const { data } = await http.get("/ccf-comment-types");
        setTypes(data);
      }
      catch {
        //ignore error
      }
    }
    
    getTypes();
  }, []);

  let filtered = [...types];
  if (commentType === "CLOSE") filtered = filtered.filter((f) => f.id === 6);
  else filtered = filtered.filter((f) => f.id !== 6);
  // if (commentType === "NEW") filtered = filtered.filter((f) => f.id !== 7);

  const title = commentType === "NEW" ? "New Comment" : "Edit Comment";

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton className="bg-warning">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <form>
        <Modal.Body>
          <Select
            name="type"
            label="Heading"
            placeholder="Heading"
            value={data.type}
            options={filtered}
            onChange={onChange}
            disabled={false}
            listKey="id"
            listName="name"
          />
          <textarea
            className="form-control"
            cols={60}
            rows={6}
            name="comment"
            label="Comment"
            placeholder="Comment"
            value={data.comment}
            onChange={onChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={onSubmit}>
            Submit
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default CCF;
